/**
 * Composition root for the repository layer.
 *
 * Modules import `repositories` from here and never reach into specific
 * implementations. Swap the implementations in this file (e.g. when adding
 * a Postgres backend) and consumers do not change.
 *
 * See ADR 0002.
 */

import type { RepositoryRegistry } from './types';
import { firestoreOrderRepository } from './firestore/orderRepository';
import { firestoreMeasurementRepository } from './firestore/measurementRepository';
import { firestoreMeasurementOpeningRepository } from './firestore/measurementOpeningRepository';
import { firestoreDeliveryRepository } from './firestore/deliveryRepository';
import { customerRepo } from './firestore/customerRepo';
import { firestoreVendorRepository } from './firestore/vendorRepository';
import { firestoreRequisitionRepository } from './firestore/requisitionRepository';
import { firestorePurchaseOrderRepository } from './firestore/purchaseOrderRepository';
import { firestoreClaimRepository } from './firestore/claimRepository';
import {
  firestoreFloatEntryRepository,
  firestoreFloatLedgerRepository,
} from './firestore/cashFloatRepository';
import { firestoreReceiptRepository } from './firestore/receiptRepository';
import { firestoreRectificationRepository } from './firestore/rectificationRepository';
import { firestoreWorkOrderRepository } from './firestore/workOrderRepository';
import { firestoreCorporateCustomerRepository } from './firestore/corporateCustomerRepository';

export const repositories: RepositoryRegistry = {
  orders: firestoreOrderRepository,
  vendors: firestoreVendorRepository,
  purchaseOrders: firestorePurchaseOrderRepository,
  requisitions: firestoreRequisitionRepository,
  workOrders: firestoreWorkOrderRepository,
  deliveryOrders: firestoreDeliveryRepository,
  rectifications: firestoreRectificationRepository,
  measurements: firestoreMeasurementRepository,
  measurementOpenings: firestoreMeasurementOpeningRepository,
  customers: customerRepo,
  corporateCustomers: firestoreCorporateCustomerRepository,
  claims: firestoreClaimRepository,
  floatLedgers: firestoreFloatLedgerRepository,
  floatEntries: firestoreFloatEntryRepository,
  receipts: firestoreReceiptRepository,
};

export type { RepositoryRegistry } from './types';
export type {
  OrderRepository,
  OrderListFilter,
  VendorRepository,
  VendorListFilter,
  PurchaseOrderRepository,
  RequisitionRepository,
  WorkOrderRepository,
  DeliveryOrderRepository,
  RectificationRepository,
  MeasurementRepository,
  MeasurementOpeningRepository,
  CustomerRepository,
  CorporateCustomerRepository,
  ClaimRepository,
  FloatLedgerRepository,
  FloatEntryRepository,
  ReceiptRepository,
} from './types';
